if (!customElements.get('recently-viewed-wrapper')) {
    class RecentlyViewedWrapper extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.classList.add('isVisible');
        }
    }

    customElements.define('recently-viewed-wrapper', RecentlyViewedWrapper);
}